import { IconCalendar, IconChevronDown } from "@pentabd/icons";
import {
  Button,
  FileInfoCard,
  FileUpload,
  InputText,
  Modal,
  Select,
  Text,
} from "@pentabd/ui";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const AddProductModal = ({ isOpen, onClose }: Props) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-5 modal_width">
        <div className="border-bottom p-6">
          <Text component="h3" size="2xl">
            {" "}
            Add Product
          </Text>
          <Text component="p" weight="light" size="sm" className="mb-5">
            {" "}
            Add new product to this procurement
          </Text>
        </div>

        <div className="row p-0 m-0 py-6">
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Name of product (English)
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Product Name"
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Name of product (Bangla)
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Product Name"
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Category
            </Text>
            <Select
              name="category"
              size="xs"
              suffix={<IconChevronDown fill="dark" size="15" />}
              options={[{ value: "value", label: "label" }]}
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Group
            </Text>
            <Select
              name="group"
              size="xs"
              suffix={<IconChevronDown fill="dark" size="15" />}
              options={[{ value: "value", label: "label" }]}
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Type
            </Text>
            <Select
              name="type"
              size="xs"
              suffix={<IconChevronDown fill="dark" size="15" />}
              options={[{ value: "value", label: "label" }]}
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Procurement
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Search"
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Unit
            </Text>
            <Select
              name="unit"
              size="xs"
              suffix={<IconChevronDown fill="dark" size="15" />}
              options={[{ value: "value", label: "label" }]}
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Unit Price
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Search"
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Ref. No.
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Search"
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Lot No.
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              size="sm"
              placeholder="Lot No."
              type="text"
            />
          </div>
          <div className=" mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Warranty Start Date
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              prefix={<IconCalendar fill="dark" size="20" />}
              size="sm"
              placeholder="Search"
              type="date"
            />
          </div>
          <div className="mt-5 col-6">
            <Text component="p" weight="semibold" size="sm" className="mb-5">
              Warranty End Date
            </Text>
            <InputText
              name="simple-input"
              onChange={(e) => {
                console.log("onChange e:", e);
              }}
              prefix={<IconCalendar fill="dark" size="20" />}
              size="sm"
              placeholder="Search"
              type="date"
            />
          </div>
          <div className="mt-5 col-12">
            <FileUpload
              id="p-id"
              name="product"
              fileTypesText="SVG, JPG, PNG or GIF"
              maxSizeText="max. 800x400px"
              onChange={function noRefCheck() {}}
              onDragOver={function noRefCheck() {}}
              onDrop={function noRefCheck() {}}
            />
          </div>
          <div className="mt-5 col-12">
            <FileInfoCard
              onClickIcon={function noRefCheck() {}}
              progressBar={{
                progress: 100,
                size: "sm",
                type: "primary",
              }}
              secondaryComponent={<></>}
              subtitle="200KB"
              title="Award 2.pdf"
            />
          </div>
          <div className="mt-5 col-12 text-end">
            <Button fill="outline" type="primary" size="xs" className="me-5">
              Cancel
            </Button>
            <Button fill="fill" type="primary" size="xs">
              Save
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddProductModal;
